import React, { useState } from "react";

export default function MahilaMandiUnityDealsForm() {
  const [product, setProduct] = useState("");
  const [customProduct, setCustomProduct] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [village, setVillage] = useState("");
  const [dealers, setDealers] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [showAbout, setShowAbout] = useState(false); 
  const [bulkQty, setBulkQty] = useState("");
  const [deliveryType, setDeliveryType] = useState("");

  const productOptions = [
    "Pickles & Preserves",
    "Handmade Soaps",
    "Baked Goods",
    "Textiles",
    "Jewelry",
    "Candles",
    "Pottery",
    "Herbal Teas",
    "Not In The List",
  ];

  const deliveryOptions = ["Pickup from Artisan", "Home Delivery", "Local Market"];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (product === "Not In The List" && customProduct.trim() === "") {
      alert("Please specify the product if 'Not In The List' is selected.");
      return;
    }
    alert(
      `Form Submitted:\nProduct: ${
        product === "Not In The List" ? customProduct : product
      }\nPIN: ${pinCode}\nVillage: ${village}\nDealer: ${selectedDealer}\nBulk Qty: ${bulkQty}\nDelivery: ${deliveryType}`
    );
  };

  const handleGetSeller = () => {
    if (pinCode.trim() || village.trim()) {
      // Dummy seller names for women-led products
      setDealers([
        "Priya's Handicrafts",
        "Sita Artisan Collective",
        "Women Weave Co-op",
      ]);
    } else {
      alert("Please enter either PIN Code or Village.");
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-black shadow-lg rounded-2xl relative">
      <h2 className="text-xl font-bold mb-4 text-white">
        UnityDeals - Women-Led Home Products
      </h2>

      {/* About UnityDeals Button */}
      <button
        type="button"
        onClick={() => setShowAbout(true)}
        className="mb-4 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
      >
        About UnityDeals
      </button>

      {/* Popup Modal */}
      {showAbout && (
        <div className="fixed inset-0 bg-black border border-green-400 bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-black border border-green-500 p-6 rounded-2xl max-w-2xl shadow-xl overflow-y-auto max-h-[80vh]">
            <h3 className="text-2xl font-bold mb-4 text-center text-yellow-100">
              About UnityDeals – Women-Led Home Industry Products
            </h3>
            <div className="space-y-4 text-white text-sm leading-relaxed">
              <p>
                Women artisans, home-based producers, and craft suppliers often sell products
                individually, leading to lower visibility and prices for their handmade goods. UnityDeals connects buyers with these empowered women, pools demand, negotiates fair prices, and ensures
                end-to-end fulfillment.
              </p>
              <ul className="list-disc pl-5">
                <li>
                  <b>Buyers & Consumers:</b> Bulk discounts on handmade soaps, pickles, textiles,
                  jewelry, and more.
                </li>
                <li>
                  <b>Artisans:</b> Verified buyers, bulk orders, increased income, and market reach.
                </li>
              </ul>
              <h4 className="text-lg font-semibold mt-4">
                How It Works (Simple 4 Steps)
              </h4>
              <ol className="list-decimal pl-5 space-y-1">
                <li>Select Need – choose product or request custom.</li>
                <li>Join Buyer Pool – combine demand with other supporters.</li>
                <li>
                  Deal Negotiation – UnityDeals secures the best bulk price with fair artisan pay.
                </li>
                <li>
                  Fulfillment & Payment – Delivery managed, payment released
                  after satisfaction.
                </li>
              </ol>
            </div>

            {/* Close Button */}
            <div className="mt-6 text-center">
              <button
                onClick={() => setShowAbout(false)}
                className="bg-red-600 text-white px-4 py-2 w-24 rounded hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 text-white">
        {/* Product Dropdown */}
        <div>
          <label className="block font-medium mb-1">Select Product</label>
          <select
            value={product}
            onChange={(e) => setProduct(e.target.value)}
            className="h-10 w-full border p-2 rounded text-black"
          >
            <option value="">-- Choose a Product --</option>
            {productOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Custom Product Input */}
        {product === "Not In The List" && (
          <div>
            <label className="block font-medium mb-1">Specify Product</label>
            <input
              type="text"
              value={customProduct}
              onChange={(e) => setCustomProduct(e.target.value)}
              placeholder="Enter your product"
              className="h-10 w-full border p-2 rounded text-black"
            />
          </div>
        )}

        {/* PIN Code & Village */}
        <div className="grid grid-cols-2 gap-2">
          <div>
            <label className="block font-medium mb-1">PIN Code</label>
            <input
              type="text"
              value={pinCode}
              onChange={(e) => setPinCode(e.target.value)}
              placeholder="Enter PIN Code"
              className="w-full border p-2 rounded text-black"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Village</label>
            <input
              type="text"
              value={village}
              onChange={(e) => setVillage(e.target.value)}
              placeholder="Enter Village"
              className="w-full border p-2 rounded text-black"
            />
          </div>
        </div>

        {/* Get Seller Button */}
        <button
          type="button"
          onClick={handleGetSeller}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Get Artisan Name
        </button>

        {/* Dealer Dropdown */}
        {dealers.length > 0 && (
          <div>
            <label className="block font-medium mb-1">Select Artisan</label>
            <select
              value={selectedDealer}
              onChange={(e) => setSelectedDealer(e.target.value)}
              className="h-10 w-full border p-2 rounded text-black"
            >
              <option value="">-- Choose Artisan --</option>
              {dealers.map((dealer) => (
                <option key={dealer} value={dealer}>
                  {dealer}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Bulk Quantity & Delivery */}
        <div>
          <label className="block font-medium mb-1">Bulk Quantity</label>
          <input
            type="number"
            value={bulkQty}
            onChange={(e) => setBulkQty(e.target.value)}
            placeholder="Enter quantity for bulk order"
            className="w-full border p-2 rounded text-black"
          />
        </div>

        <div>
          <label className="block font-medium mb-1">Delivery Type</label>
          <select
            value={deliveryType}
            onChange={(e) => setDeliveryType(e.target.value)}
            className="h-10 w-full border p-2 rounded text-black"
          >
            <option value="">-- Choose Delivery --</option>
            {deliveryOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 w-24 rounded hover:bg-green-700"
        >
          Submit
        </button>
      </form>
    </div>
  );
}